import React from 'react';
import Catalog from './Catalog';

function Sessions() {
  return (
    <Catalog
      defaultTab="groups"
      canonicalPath="/sessions"
    />
  );
}

export default Sessions;
